import angular from 'angular';

import Component from './required-field.component';

const RequiredFieldModule = angular
    .module('control-room.commons.form.components.required-field', [])
    .component('crRequiredField', Component);

export default RequiredFieldModule;
